import * as Yup from "yup"; 

import { Strings } from "@app/constants";

export const contactUsSchema = Yup.object()
  .shape({
    name: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.firstName)
    ),
    email: Yup.string()
      .email(Strings.validation.validEmail)
      .required(Strings.validation.fieldRequired(Strings.auth.email)),
    state: Yup.string().optional(),
    city: Yup.string().optional(),
    zipCode: Yup.string().optional(),
    message: Yup.string().required(
      Strings.validation.fieldRequired("message")
    ),
  })
  .required();
